import { Component, OnInit, Input } from "@angular/core";
import { Tenant } from "../models/tenant";

@Component({
  selector: "app-tenant",
  templateUrl: "./tenant.component.html",
  styleUrls: ["./tenant.component.scss"],
})
export class TenantComponent implements OnInit {
  constructor() {}
  @Input() public tenant: Tenant;
  ngOnInit(): void {}
}
